import MenuTabs from './container/MenuTabs';

export default MenuTabs;
